export default __webpack_public_path__ + "src/images/galleries/0/info_cn-db42e7.png";